<div
    class="ap-illustration-container"
    [apInlineSVG]="getAssetUrl()"
    [setSVGAttributes]="size()"
    (svgInserted)="onSvgInserted($event)"
></div>
